export const webglConstants = {
    CHANGE_AVAILABILITY : 'CHANGE_WEBGL_AVAILABILITY',
    CHANGE_VISIBILITY: 'CHANGE_WEBGL_VISIBILITY'
};

export const generatorConstants = {
    CHANGE_MODEL: 'CHANGE_GENERATOR_MODEL',
    RESET_OPTIONS: 'RESET_GENERATOR_OPTIONS',
    FIX_OPTIONS: 'FIX_GENERATOR_OPTIONS',
    FIX_NOISE_OPTION: 'FIX_NOISE_OPTION',
    PERTURB_NOISE: 'PERTURB_NOISE',
    SET_OPTIONS: 'SET_GENERATOR_OPTIONS',
    SET_NOISE_VALUE: 'SET_NOISE_VALUE',
    SET_INPUT: 'SET_GENERATOR_INPUT',
    APPEND_RESULT: 'APPEND_GENERATOR_RESULT',
    CHANGE_MODEL_OPTION: 'CHANGE_GENERATOR_MODEL_OPTION',
    SET_TRANSITION_START: 'SET_TRANSITION_START',
    SET_TRANSITION_END: 'SET_TRANSITION_END',
    APPEND_TRANSITION_MIDDLE: 'APPEND_TRANSITION_MIDDLE',
    REMOTE_COMPUTING:'REMOTE_COMPUTING',
    CHANGE_CURRENT_INDEX:'CHANGE_CURRENT_INDEX',
    SET_COUNT: 'SET_COUNT',
    SET_TRANSITION_COUNT: 'SET_TRANSITION_COUNT',
    CLEAR_TRANSITION: 'CLEAR_TRANSITION',
    CHANGE_NOISE_INTERPOLATION: 'CHANGE_NOISE_INTERPOLATION'
};



// WEBPACK FOOTER //
// ./src/_constants/generator.constants.js